// When upgrading @mission.io/styles from v1 to v3, a lot of the properties of the theme object were removed.
// The `tempTheme` object exported here is an object used to make the transition to @mission.io/styles@3 and tailwind
// more seamless quicker. The keys are the references to tailwind stiles, and the values are the corresponding
// properties. This should not be used in new code.

export const _tempTheme = {
	// spacing
	spacing1: '0.25rem', // previously theme.spacingHalf
	spacing2: '0.5rem', // previously theme.spacing
	spacing4: '1rem', // previously theme.spacing2x
	spacing6: '1.5rem', // previously theme.spacing3x
	spacing8: '2rem', // previously theme.spacing4x
	spacing10: '2.5rem', // previously theme.spacing5x
	spacing16: '4rem', // previously theme.spacing8x

	// font sizes
	text_xs: '0.75rem', // previously theme.fontxxxs
	text_sm: '0.875rem', // previously theme.fontxxs and theme.fontxs
	text_base: '1rem', // previously theme.fonts
	text_lg: '1.125rem', // previously theme.fontm
	text_2xl: '1.5rem', // previously theme.fontl
	text_3xl: '1.875rem', // previously theme.fontxl
	text_4xl: '2.25rem', // previously theme.fontxxl

	// font weights
	font_light: '300', // previously theme.fontLight
	font_normal: '400', // previously theme.fontRegular
	font_medium: '500', // previously theme.fontSlightBold
	font_semibold: '600', // previously theme.fontSemibold
	font_bold: '700', // previously theme.fontBold
}
